export default __webpack_public_path__ + "static/media/address.b591b232.jpg";